import {
  getFontCss,
  styleConstants,
  Tag,
  TagScales,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import AnimatedTableChevron from 'src/components/AnimatedTableChevron/AnimatedTableChevron'
import LoadingBoxBottom from 'src/components/LoadingBoxBottom/LoadingBoxBottom'
import NoPeople from 'src/components/NoPeople/NoPeople'
import SvgOrganizationFilled from 'src/components/Svgs/SvgOrganizationFilled'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import Lnk from 'src/navigation/Lnk'
import { peopleMembersDetailUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

interface PeopleMembersListSmallProps {
  people: UserListModel[]
  loading?: boolean
  sortableProps: {
    setSort: (field: string) => void
    sortBy?: string
    sortDescending?: boolean
  }
}

const PeopleMembersListSmall: React.FC<PeopleMembersListSmallProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      {props.people.length > 0 &&
        props.people.map((person, i) => {
          const {
            firstName,
            lastName,
            id,
            orgRoleDisplayTagTitle,
            hasOrgOwnerPermissions,
          } = person

          return (
            <Lnk
              css={css`
                padding: 24px 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 60px;
                border-top: 1px solid ${styleConstants.colors.gray_light};
                background-color: ${styleConstants.colors.gray_lightest};

                &:last-child {
                  border-bottom: 1px solid transparent;

                  &:hover {
                    border-bottom: 1px solid ${themeConstants.colors.cta_dark};
                  }
                }
                &:hover {
                  background-color: rgba(${styleConstants.colors.blue}, 0.1);
                  border-top: 1px solid ${themeConstants.colors.cta_dark};

                  .animated-table-chevron {
                    transform: translateX(4px);
                  }
                  & + * {
                    border-top: 1px solid ${themeConstants.colors.cta_dark};
                  }
                }
                &:last-child {
                  border-bottom: 1px solid ${styleConstants.colors.gray_light};
                }
              `}
              key={i}
              to={peopleMembersDetailUrl(id)}
              ariaLabelSource={'People Details'}
            >
              <div
                css={css`
                  display: flex;
                  min-width: 0;
                `}
              >
                <UserAvatar
                  css={css`
                    margin-right: 10px;
                  `}
                  user={person}
                  size={AvatarSizes.Small}
                />
                <div
                  css={css`
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    min-width: 0;
                  `}
                >
                  {firstName && lastName && (
                    <span
                      css={css`
                        ${getFontCss(
                          14,
                          themeConstants.colors.font_primary,
                          styleConstants.fontFamilies.medium,
                        )}
                      `}
                    >
                      {firstName} {lastName}
                    </span>
                  )}
                  {!person.deactivated ? (
                    <Tag
                      css={css`
                        width: max-content;
                      `}
                      text={translate(orgRoleDisplayTagTitle)}
                      icon={
                        hasOrgOwnerPermissions ? (
                          <SvgOrganizationFilled style={TagScales.medium} />
                        ) : undefined
                      }
                    />
                  ) : (
                    <span
                      css={css`
                        ${getFontCss(
                          12,
                          styleConstants.colors.gray_darkest,
                          styleConstants.fontFamilies.regular,
                        )};
                      `}
                    >
                      {translate('Deactivated')}
                    </span>
                  )}
                </div>
              </div>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                `}
              >
                <AnimatedTableChevron
                  css={css`
                    transform-origin: top right;
                    transform: scale(0.7);
                  `}
                />
              </div>
            </Lnk>
          )
        })}

      {props.loading ? (
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            flex-grow: 2;
          `}
        >
          <LoadingBoxBottom />
        </div>
      ) : (
        <div
          css={css`
            display: flex;
            justify-content: center;
          `}
        >
          {props.people.length === 0 && (
            <NoPeople
              titleText={translate('No one matched your search.')}
              topSubtitleText={
                <div
                  css={css`
                    flex-direction: column;
                  `}
                >
                  {translate('Check the keyword you typed for any errors.')}
                </div>
              }
            />
          )}
        </div>
      )}
    </div>
  )
}

export default PeopleMembersListSmall
